<template>
  <v-dialog v-model="dialog" max-width="660" scrollable>
    <v-card height="470" class="modules-select">
      <v-card-title class="modules-title pa-5">
        <span class="modules-title-span pr-1">Configurar módulos localmente</span>
        <copy-button tooltip="Copiar DB Name" size="xs" @click="copyDbName" />
        <v-spacer />
        <mf-button label="Ver documentação" color="marca-0-l40" icon="open_in_new" icon-position="right" @click="redirectToDoc" />
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col v-for="(value, key) in localModules" :key="key" cols="6">
              <v-checkbox
                v-model="localModules[key]"
                :ripple="false"
                :label="key"
                :disabled="key === 'dynamic_sales'"
                hide-details
                single-line
                color="primary"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <div class="actions-buttons d-flex justify-end pt-4 pb-5 px-5">
        <mf-button outlined label="Cancelar" text-transform="none" class="unset-capitalize" @click="cancel" />
        <mf-button label="Confirmar" text-transform="none" color="marca-0-l10" class="unset-capitalize" @click="submit" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import CopyButton from '@/components/CopyButton.vue'
import { modules } from '@/config'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    CopyButton,
  },
  data: () => ({
    dialog: false,
    localModules: cloneDeep(modules),
  }),
  watch: {
    dialog(value) {
      if (value) this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    cancel() {
      this.dialog = false
    },
    submit() {
      this.$setAllowedModules(this.localModules)
      this.$router.replace('/home')
      this.cancel()
    },
    redirectToDoc() {
      const routeURL = 'https://mercafacil.getoutline.com/doc/modulos-cbm-KqklOt2MDh'
      window.open(routeURL, '_blank')
    },
    getData() {
      const allowedModules = this.$getAllowedModules()

      for (let localKey in this.localModules) {
        this.$set(this.localModules, localKey, Boolean(allowedModules[localKey]))
      }
    },
    copyDbName() {
      navigator.clipboard.writeText(this.$getLoggedUser().db_name)
    },
  },
}
</script>
<style lang="scss" scoped>
.modules-select {
  .modules-title {
    .modules-title-span {
      font-family: Lato;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 26.4px */
      letter-spacing: 0.22px;
      color: $cinza-d10;
    }
  }
  .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
  }
  .actions-buttons {
    gap: 16px;
  }
}
</style>
